import { NotificationPreferencesPanel } from "../components/notification-preferences-panel"
import { PageContainer } from "../components/page-container"
import { PageHeader } from "../components/page-header"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

export function SettingsPage() {
	const { locale } = useLocale()
	const t = getTranslations(locale)

	return (
		<div className="min-h-screen w-full bg-background">
			<PageContainer variant="narrow" chrome="bare">
				<PageHeader title={t.settings.title} />
				<NotificationPreferencesPanel />
			</PageContainer>
		</div>
	)
}
